<cerrix-dialog [name]="name" [icon]="icon" [attr.data-uiid]="dataUiid" (closed)="closed.emit()">
    <div header-title>
        <span> {{ title }} </span>
    </div>
    <div class="confirm-dialog-content" dialog-content>
        <span class="confirm-dialog-description"> {{ description }} </span>
        <ng-content></ng-content>
    </div>
    <div class="confirm-dialog-footer" dialog-footer>
        <cerrix-button
            buttonType="secondary"
            secondaryColor="filled"
            buttonSize="big"
            (click)="cancel.emit()"
            [attr.data-uiid]="dataUiid + '--cancel'"
            >{{ cancelText }}</cerrix-button
        >
        <cerrix-button
            buttonSize="big"
            [primaryColor]="confirmColor"
            (click)="confirm.emit()"
            [attr.data-uiid]="dataUiid + '--confirm'"
            [waitingOnResult]="waitingOnResult"
            [showResultText]="showResultText"
        >
            {{ confirmText }}</cerrix-button
        >
    </div>
</cerrix-dialog>
